import { Routes, Route, Outlet } from "react-router";
import Home from "./pages/Home";
import Navbar from './components//navbar';
import BarGen from './components/bargen';
import QRGen from './components/qrgen';
import BarcodeScanner from './components/barreader'
import Html5Scanner from './components/html5QRcode'
import TextToSpeech from './components/TextToSpeech'
import ExTextToSpeech from './components/text2speedchandsave'
import ImageResizer from './pages/resizeimg/imageresizer';

import './App.css';

function App() {

  return (
    <div className="">
      <Navbar />
       <div className="mt-12">
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route index element={<Home />} />

        <Route path="bargen" element={<BarGen />} />
        <Route path="barreader" element={<BarcodeScanner />} />
        <Route path="qrgen" element={<QRGen />} />
        <Route path="htmlreader" element={<Html5Scanner />} />
        <Route path="text2speech" element={<TextToSpeech />} />
        <Route path="extext2speech" element={<ExTextToSpeech />} />
        <Route path="imgresize" element={<ImageResizer />} />

      </Routes>
        <Outlet />
      </div>
    </div>
  );
}

export default App;
